type LocaleType = {
  [key: string]: {
    [key: string]: string;
  };
};

export const LOCALE: LocaleType = {
  EN: {
    REQUIRED: 'This field is required',
    EMAIL: 'Please enter valid email',
    TEL: 'Only numbers and + are allowed',
    NUMBER: 'Only digits are allowed',
    REPORTER_NAME: 'Please enter valid name',
    REPORTER_STATUS: 'Please enter valid status',
    PATIENT_NAME: 'Only uppercase letters are allowed',
    PATIENT_AGE: 'Please enter valid age from 0 to 120',
    PATIENT_GENDER: 'Only letters allowed, from 4 to 10 characters',
    DRUG_NAME: 'Please enter valid drug name',
    DRUG_MANUFACTURER: 'Please enter valid drug manufacturer',
    DRUG_MEDICAL_FORM: 'Please enter valid drug medical form',
    DRUG_SERIAL: 'Only letters, digits, underscores, or hyphens',
    MINIMUM_TEXT: 'Minimum number of characters allowed is ',
    MINIMUM_NUMBER: 'Minimum value is ',
    MAXIMUM_TEXT: 'Maximum number of characters allowed is ',
    MAXIMUM_NUMBER: 'Maximum value is ',
    TEXTAREA: 'Adding external links and HTML tags is prohibited',
  },
  UA: {
    REQUIRED: "Це поле обов'язкове для заповнення",
    EMAIL: 'Це не є дійсною електронною поштою',
    TEL: 'Дозволяються лише цифри та +',
    NUMBER: 'Лише цифри',
    REPORTER_NAME: 'Введіть коректне імʼя',
    REPORTER_STATUS: 'Введіть коректний статус',
    PATIENT_NAME: 'Лише великі літери',
    PATIENT_AGE: 'Введіть коректний вік числом від 0 до 120',
    PATIENT_GENDER: 'Лише літери, від 4 до 10 символів',
    DRUG_NAME: 'Введіть коректну назву препарату',
    DRUG_MANUFACTURER: 'Введіть коректного виробника препарату',
    DRUG_MEDICAL_FORM: 'Введіть коректну лікарську форму препарату',
    DRUG_SERIAL: 'Тільки літери, цифри, підкреслення або дефіси',
    MINIMUM_TEXT: 'Мінімально допустима кількість символів ',
    MINIMUM_NUMBER: 'Мінімальне значення ',
    MAXIMUM_TEXT: 'Максимально допустима кількість символів ',
    MAXIMUM_NUMBER: 'Максимальне значення ',
    TEXTAREA: 'Додавання сторонніх посилань та HTML-тегів заборонено',
  },
};
